import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const AgentFeeProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `FranchiseAgentFees/GetByFranchise/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `FranchiseAgentFees/Get/${props.feeId}`, method: 'GET', secure: true });
    }, [execute]);

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `FranchiseAgentFees/${props.franchiseAgentFeeId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `FranchiseAgentFees`, method: 'POST', payload: props.agentFee, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `FranchiseAgentFees`, method: 'POST', payload: props.agentFee, secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const value = { listRecords, selectRecord, data, clearData, deleteRecord, createRecord, updateRecord, newRecord };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useAgentFeeStore = () => React.useContext(Context);